import { nanoid } from 'nanoid';
import { useState } from 'react';
import { useCookies } from 'react-cookie';

const poiAutocompletionSessionCookieName = 'poiAutocompletionSession';
export const usePOIAutocompleteSessionToken = (): {
  sessionToken?: string;
  setPOISessionToken: () => void;
  clearPOISessionToken: () => void;
} => {
  const [cookies, setCookie, removeCookie] = useCookies<'poiAutocompletionSession'>([
    'poiAutocompletionSession',
  ]);

  const poiAutocompletionSession = cookies.poiAutocompletionSession as string | undefined;

  const [sessionToken, setSessionToken] = useState<string | undefined>(poiAutocompletionSession);

  const setPOISessionToken = () => {
    const newPoiAutocompletionSessionCookie = nanoid();
    setSessionToken(newPoiAutocompletionSessionCookie);

    setCookie(poiAutocompletionSessionCookieName, newPoiAutocompletionSessionCookie, {
      maxAge: 10 * 60,
      path: '/',
      sameSite: true,
    });
  };
  const clearPOISessionToken = () => {
    removeCookie(poiAutocompletionSessionCookieName, {
      path: '/',
      sameSite: true,
    });
  };
  return { sessionToken, setPOISessionToken, clearPOISessionToken };
};
